var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterView',{on:{"onStartEvent":_vm.onStartEvent,"onEndEvent":_vm.onEndEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }